/**
 * Determines if the element is completely in the viewport.
 *
 * @param {HTMLElement} element
 */
export const isInViewport = element => {
  const clientRect = element.getBoundingClientRect();
  const top = clientRect.top;
  const bottom = clientRect.bottom;

  return top >= 0 && bottom <= window.innerHeight;
};



// WEBPACK FOOTER //
// ./src/common/Helpers/DOMHelpers.js